import gear from '../../../giphy.gif'
import { FloatingLabel, Label } from "@progress/kendo-react-labels";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { useLocation, useNavigate } from 'react-router-dom'
import React from 'react';

export default function LandingPage() {

    const navigate = useNavigate();
    const location = useLocation();
    const [studyID, setStudyID] = useState<string | undefined>(undefined);
    const [psGuid, setPsGuid] = useState<string | undefined>(undefined);
    const [theme, settheme] = useState<string | undefined>(undefined);

    const handleStartSyrvey = () => {

        if (studyID && psGuid) {
            navigate(`${location.pathname??''}?studyid=${studyID}&psguid=${psGuid}&theme=${theme ?? ""}`);
            window.location.reload();
        }
        else if (studyID) {
            navigate(`${location.pathname??''}?studyid=${studyID}&theme=${theme ?? ""}`);
            window.location.reload();
        }
    }

    return (
        <div>
            <div className='flex md:flex-row flex-col justify-evenly'>
                <FloatingLabel
                    className='basis-1/4 pr-3'
                    label={"Study ID:"}
                    editorId={"studyid"}
                    editorValue={studyID}
                >
                    <Input
                        className="h-10"
                        autoFocus
                        id={"studyid"}
                        value={studyID}
                        onChange={(e: InputChangeEvent) => setStudyID(e.value)}
                    />
                </FloatingLabel>

                <FloatingLabel
                    className='basis-1/4 pr-3'
                    label={"PsGUID:"}
                    editorId={"PsGUID"}
                    editorValue={psGuid}
                >
                    <Input
                        className='p-1 h-10'
                        id={"PsGUID"}
                        value={psGuid}
                        onChange={(e: InputChangeEvent) => setPsGuid(e.value)}
                    />
                </FloatingLabel>
                <FloatingLabel
                    className='basis-1/4 pr-3'
                    label={"Theme:"}
                    editorId={"theme"}
                    editorValue={theme}
                >
                    <Input
                        className='p-1 h-10'
                        id={"theme"}
                        value={theme}
                        onChange={(e: InputChangeEvent) => settheme(e.value)}
                    />
                </FloatingLabel>
                <Button
                    className='basis-1/4 max-h-10 top-5 font-semibold'
                    size={"small"}
                    themeColor={"success"}
                    fillMode={"solid"}
                    rounded={"small"}
                    onClick={handleStartSyrvey}
                >Start Survey</Button>
            </div>
            <img alt="SurveyEngine" className='flex lg:pt-20 pt-10 w-full sm:justify-stretch' src={gear} />
            <Label className='flex text-lg p-10 justify-center'>Survey Engine</Label>
        </div>
    )
}